import LocalStorageConst from '../../constant/localstorage.constant';
import { saveToLocalStorage } from './saveToLocalStorage';

export const setKeyValueInLocalStorage = function (key, value) {
  if (key && value) {
    saveToLocalStorage(LocalStorageConst.prefix + key, value);
  }
};
